import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConferenceRegistrantViewModel, ConferenceViewModel, ConferenceViewModelWithDetails, OrganizationViewModel, RegistrantSearchParameters } from '../../_models/generatedModels';
import { AnalyticsService } from '../../_services/analytics.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { OrganizationService } from '../../_services/generatedServices';
import { SettingsProvider } from '../../_services/settingsProvider.service';
import { ToasterService } from '../../_services/toaster.service';
import { CheckinPreviewModalComponent } from './checkin-preview-modal.component';
import { Subscription, interval } from 'rxjs';
import { IdleService } from "../../_services/idle.service";
import Keyboard from "simple-keyboard";
import { CheckinService } from "../../_services/checkin.service";


declare var zE: any;


@Component({
  selector: 'bxl-on-site-checkin',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'on-site-checkin.component.html',
})
export class OnSiteCheckinComponent implements OnInit, OnDestroy {
  initialized = false;
  @ViewChild('myForm') myForm: FormGroupDirective;
  @ViewChild('email') email: ElementRef;
  organization: OrganizationViewModel;
  conference: ConferenceViewModel;
  model: RegistrantSearchParameters;


  submitComplete: Promise<{}> | undefined;
  conferenceSlug: string;
  conferenceStatus: Subscription;
  public checkInMode: boolean;
  public reKeyMode: boolean;

  inputName = "name";
  inputs = {
    name: ""
  };

  keyboard: Keyboard;
  private currentInput: any;
  keyboardVisible: boolean;
   searchResults: ConferenceRegistrantViewModel[];

  constructor(private title: AnalyticsService, idleService: IdleService, private activeModal: NgbActiveModal, public checkinService: CheckinService, public auth: AuthenticationService, public settings: SettingsProvider, private route: ActivatedRoute, private toaster: ToasterService, private router: Router, private orgService: OrganizationService, private modalService: NgbModal) {
    idleService.idle$.subscribe(s => {
      this.reset();
    });
    idleService.wake$.subscribe(s => console.log('im awake!'));
    this.checkinService.rfidEnabled = false;
  }

  ngOnInit(): void {
    zE('webWidget', 'hide');

    this.model = new RegistrantSearchParameters();
    this.model.currentPage = 0;
    this.model.pageSize = 20;

    this.route.paramMap.subscribe((parentParam) => {
      this.conferenceSlug = parentParam.get('conferenceSlug');
      console.log('confslug' + this.conferenceSlug);
      this.orgService.getConferenceBySlugBasic(this.conferenceSlug).subscribe(
        (conference) => {
          this.organization = conference.organization;
          this.conference = conference;
          //this.model.searchText = 'chris@behaviorlive.com';
        },
        (error) => {
          this.router.navigate(['/notfound']);
        }
      );

    });
    this.conferenceStatus = interval(10000).subscribe((val) => this.getData());

  }


  ngOnDestroy(): void {
    this.conferenceStatus.unsubscribe();
    console.log('ngOnDestroy');

    this.keyboard?.destroy();

  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit');
    if (this.checkinService.rfidEnabled) {
      this.keyboard = new Keyboard({
        debug: true,
        theme: "hg-theme-default hg-theme-ios",
        inputName: this.inputName,
        onChange: (input) => this.onChange(input),
        onKeyPress: (button) => this.onKeyPress(button),
        disableCaretPositioning: false,
        preventMouseDownDefault: true, // If you want to keep focus on input,
        layout: {
          default: [
            "q w e r t y u i o p {bksp}",
            "a s d f g h j k l {enter}",
            "{shift} z x c v b n m , . {shift}",
            "{alt} @ {space} .com {downkeyboard}"
          ],
          shift: [
            "Q W E R T Y U I O P {bksp}",
            "A S D F G H J K L {enter}",
            "{shiftactivated} Z X C V B N M , . {shiftactivated}",
            "{alt} @ {space} .com {downkeyboard}"
          ],
          alt: [
            "1 2 3 4 5 6 7 8 9 0 {bksp}",
            `@ # $ & * ( ) ' " {enter}`,
            "{shift} % - _ + = / ; : ! ? {shift}",
            "{alt} @ {space} .com {downkeyboard}"
          ]
        },
        display: {
          "{alt}": ".?123",
          "{shift}": "⇧",
          "{shiftactivated}": "⇧",
          "{enter}": "return",
          "{bksp}": "⌫",
          "{altright}": ".?123",
          "{downkeyboard}": "🞃",
          "{space}": "            ",
          "{default}": "ABC",
          "{back}": "⇦"
        }
      });
    }

    /**
     * Since we have default values for our inputs,
     * we must sync them with simple-keyboard
     */
    //this.keyboard.replaceInput(this.inputs);
  }

  onInputFocus = (event: any) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }

    this.keyboardVisible = true;
    this.inputName = event.target.id;
    this.currentInput = event.target;

    var selectionStart = event.target.selectionStart;
    console.log(selectionStart);

    console.log("Focused input", this.inputName);

    this.keyboard.setOptions({
      inputName: event.target.id
    });

  };

  reset() {
    this.checkInMode = false;
    this.model.searchText = '';
    this.searchResults = [];
    this.myForm.resetForm();

    if (!this.checkinService.rfidEnabled) {
      return;
    }
    this.keyboardVisible = false;
    this.checkInMode = false
    this.keyboard.setInput('', this.currentInput?.id);
    if (this.currentInput) {
      this.currentInput.value = '';
      this.currentInput.dispatchEvent(new Event("change"));
      this.currentInput.dispatchEvent(new Event("input"));
    }

  }

  setInputCaretPosition = (elem: any, pos: number) => {
    console.log("setInputCaretPosition", elem, pos);
    if (elem.setSelectionRange) {
      elem.focus();
      elem.setSelectionRange(pos, pos);
    }
  };

  onInputChange = (event: any) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }
    console.log("onInputChange", event.target.value);
    this.keyboard.setInput(event.target.value);
  };

  public mouseUp($event: any) {

    // var selectionStart = $event.target.selectionStart;
    // console.log(selectionStart);
    // this.keyboard.setCaretPosition(3);
    // this.setInputCaretPosition($event.target, 3);
  }


  onChange = (input: string) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }

    this.currentInput.value = input;
    //this.model.searchText = input;
    console.log("Input changed", input);

    /**
     * Synchronizing input caret position
     * This part is optional and only relevant if using the option "preventMouseDownDefault: true"
     */
    let caretPosition = this.keyboard.caretPosition;

    if (caretPosition !== null)
      this.setInputCaretPosition(
        document.querySelector(`#${this.inputName}`),
        caretPosition
      );

    console.log("caretPosition", caretPosition);
    this.currentInput.dispatchEvent(new Event("change"));
    this.currentInput.dispatchEvent(new Event("input")); // Use for Chrome/Firefox/Edge
  };

  onKeyPress = (button: string) => {
    if (!this.checkinService.rfidEnabled) {
      return;
    }

    console.log("Button pressed", button);

    /**
     * If you want to handle the shift and caps lock buttons
     */
    //if (button === "{shift}" || button === "{lock}") this.handleShift();
    if (button.includes("{") && button.includes("}")) {
      this.handleLayoutChange(button);
    }
  };

  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };


  handleLayoutChange(button) {
    let currentLayout = this.keyboard.options.layoutName;
    let layoutName;

    console.log(currentLayout);

    switch (button) {
      case "{shift}":
      case "{shiftactivated}":
      case "{default}":
        layoutName = currentLayout === "default" ? "shift" : "default";
        break;

      case "{alt}":
      case "{altright}":
        layoutName = currentLayout === "alt" ? "default" : "alt";
        break;

      case "{smileys}":
        layoutName = currentLayout === "smileys" ? "default" : "smileys";
        break;

      default:
        break;
    }

    if (layoutName) {
      this.keyboard.setOptions({
        layoutName: layoutName
      });
    }
  }

  getData() {
    this.orgService.getConferenceBySlugBasic(this.conferenceSlug).subscribe(
      (conference) => {
        this.conference.registrationOpen = conference.registrationOpen;
      }
    );
  }

  checkin(content) {
    if (!this.myForm.valid) {
      this.myForm.form.markAllControlsDirty();
      return;
    }

    this.email.nativeElement.blur();


    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.orgService.getRegistrantsForConference(this.organization.id.toString(), this.conference.id, this.model).subscribe(
        (result) => {
          if (result.resultCount == 0) {
            this.toaster.messageDialog('No Registration found under this email address. Please try a different email or speak to an agent.', 'No Match').subscribe();
            resetButton();
            return;
          }

          if (result.resultCount >= 1 && result.users[0].isSuspended) {
            this.toaster.messageDialog('This registration is currently suspended. Please speak to an agent.', 'Suspended').subscribe();
            resetButton();
            return;
          }

          if (result.resultCount > 1 ) {
            this.searchResults = result.users;
            this.modalService.open(content, {size: 'lg', centered: true, backdrop: 'static', keyboard: false}).result.then((result) => {}, (reason) => {});

            resetButton();
            return;
          }

          this.reset();

          this.checkinService.user = result.users[0];
          this.checkinService.conference = this.conference;
          this.checkinService.organization = this.organization;
          this.checkinService.mode = this.reKeyMode ? 'rekey' : 'checkin';
          this.router.navigate(['modify'], {relativeTo: this.route});


          resetButton();
        },
        (error) => {
          resetButton();
        }
      );
    });
  }

  public checkInClicked() {
    this.checkInMode = true;
    this.reKeyMode = false;
  }

  public registerClicked() {

  }

  public rfidClicked() {
    this.checkInMode = false;
    this.reKeyMode = true;
  }

  public cancel() {
    this.reKeyMode = false;
    this.checkInMode = false;
  }

  public resultSelected(result: ConferenceRegistrantViewModel, modal: any) {
    modal.close();
    this.checkinService.user = result;
    this.checkinService.conference = this.conference;
    this.checkinService.organization = this.organization;
    this.checkinService.mode = this.reKeyMode ? 'rekey' : 'checkin';
    this.router.navigate(['modify'], {relativeTo: this.route});
  }
}
